import { darken } from "polished";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { color, Flex, radius, shadow, SVG, Text, View } from "./Styles";

export default ({ screen }) => {
  const { t, i18n } = useTranslation();
  const [menuVisable, setMenuVisable] = useState(false);

  return (
    <Flex aic>
      {screen === "mobile" ?
        null :
        <SVG
          svg={IconDropdown}
          height={1.5}
          mr={0.75}
          r={radius.rounded}
          fill={color.black}
          onMouseEnter={() => setMenuVisable(true)}
          onClick={() => setMenuVisable(true)}
          b={color.border.md}
        />
      }


      {menuVisable && (
        <Menu
          aifs
          p={0.75}
          r={radius.lg}
          s={shadow.lg}
          bg={color.white}
          z={1000}
          onMouseLeave={() => setMenuVisable(!menuVisable)}
        >
          <SVG
            svg={IconDropdown}
            height={1.5}
            mr={0.75}
            r={radius.rounded}
            fill={color.black}
            bg={color.washedGray}
            onClick={() => setMenuVisable(false)}
            b={color.transparent}
          />
          <View>
            <Flex column pr={1} gap={1.5}>
              <NavLink to="/">
                <SVG
                  svg={i18n.language === "zh" ? poolLogo : poolLogoEN}
                  height={1.5}
                  fill={color}
                />
              </NavLink>

              <a
                href="https://rent.liebi.com"
                target="_blank"
                rel="noopener noreferrer"
                alt="猎币闪租"
              >
                <SVG
                  svg={i18n.language === "zh" ? rentLogo : rentLogoEN}
                  height={1.5}
                  fill={color}
                />
              </a>
            </Flex>

            <Flex
              column
              gap={0.5}
              mt={1.5}
              pt={0.75}
              pr={0.5}
              pb={0.5}
              bt={color.border.md}
            >
              <ProductLogo
                icon={LogoVoter}
                name={t("IOST 投票宝")}
                url="https://tool.liebi.com/iostvoter/"
              />
              {/* <ProductLogo
                icon={LogoMonitor}
                name="EOS 账号监控"
                url="https://stake.liebi.com/cpu/monitor"
              /> */}
            </Flex>
          </View>
        </Menu>
      )}

      <NavLink to="/">
        <SVG
          svg={i18n.language === "zh" ? poolLogo : poolLogoEN}
          height={1.5}
          fill={color}
        />
      </NavLink>
    </Flex>
  );
};

const Menu = styled(Flex)`
  position: absolute;
  top: 0.5em;
  left: 0.5em;
`;

const ProductLogo = ({ icon, name, url }) => (
  <a href={url ? url : null} target="blank">
    <ProductLogoStyle aic r={radius.md} pr={0.75}>
      <SVG svg={icon} height={2} fill={color.gray} />
      <Text scale={-1} color={color.gray}>
        {name}
      </Text>
    </ProductLogoStyle>
  </a>
);

const ProductLogoStyle = styled(Flex)`
  background: ${color.washedGray};
  svg {
    fill: ${color.gray};
  }
  @media (hover: hover) {
    :hover {
      background: ${darken(0.02, color.washedGray)};
    }
  }
`;

const poolLogo = () => (
  <svg
    width="167"
    height="32"
    viewBox="0 0 167 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M51.5179 4.524V7.5H54.9419V10.508H50.8779V13.644H69.6939V10.508H65.5659V7.5H69.1499V4.524H65.5659V1.452H62.3019V4.524H58.1739V1.452H54.9419V4.524H51.5179ZM58.1739 10.508V7.5H62.3019V10.508H58.1739ZM67.8379 15.34H52.9259V30.604H56.1579V29.42H64.6059V30.636H67.8379V15.34ZM56.1579 26.412V23.82H64.6059V26.412H56.1579ZM56.1579 20.94V18.316H64.6059V20.94H56.1579ZM49.0219 1.516C48.1899 2.86 47.2939 4.108 46.3659 5.196C45.5339 4.012 44.5739 2.86 43.4539 1.74L40.8299 3.756C42.0779 4.876 43.1339 6.124 44.0299 7.468C42.7499 8.556 41.4379 9.42 40.0299 10.092L41.8219 13.004C43.2299 12.108 44.4459 11.212 45.5339 10.38C45.5339 10.38 45.5339 10.412 45.5659 10.476C45.8859 11.34 46.1419 12.364 46.3339 13.548C44.8299 16.012 42.7179 18.156 39.9979 19.98L41.8859 22.796C43.7099 21.42 45.3419 19.788 46.7819 17.868C46.8139 18.508 46.8459 19.244 46.8459 20.012C46.8459 23.916 46.5259 26.252 45.9499 27.02C45.6939 27.34 45.1819 27.532 44.3499 27.532C43.4219 27.532 42.4299 27.468 41.4059 27.34L42.3979 30.444C43.0699 30.476 43.9659 30.508 45.0859 30.508C46.3339 30.508 47.3259 30.22 48.0939 29.644C49.3739 28.556 50.0459 25.42 50.0459 20.172C49.9499 15.404 49.4379 11.724 48.5099 9.132C48.3819 8.812 48.2219 8.46 48.0619 8.108C49.2779 6.828 50.5259 5.196 51.7739 3.212L49.0219 1.516ZM95.8379 26.988C97.9179 26.988 98.9739 25.836 98.9739 23.532V10.476H88.5419V6.156C93.0219 5.708 96.9579 5.068 100.35 4.236L98.6539 1.324C91.5499 2.86 82.9099 3.66 72.7019 3.66L73.7579 6.796C77.8539 6.796 81.6299 6.668 85.1499 6.444V10.476H74.6859V27.052H78.0139V13.676H85.1499V30.892H88.5419V13.676H95.6459V22.796C95.6459 23.436 95.3259 23.788 94.7179 23.788L91.9339 23.628L92.7979 26.988H95.8379ZM107.87 5.868C107.166 10.124 105.822 13.964 103.774 17.42L105.566 20.3C105.95 19.724 106.366 19.084 106.75 18.444V29.772H109.886V27.692H114.654C114.462 28.044 114.238 28.428 113.982 28.812L116.542 31.116C119.166 27.116 120.542 21.804 120.67 15.212V8.588H133.214V5.324H127.23C126.814 3.788 126.398 2.38 125.95 1.164L122.558 1.74C123.07 2.828 123.518 4.044 123.934 5.324H117.342V15.212C117.246 19.82 116.51 23.66 115.134 26.7V12.172H109.566C110.206 10.188 110.75 8.108 111.134 5.868H115.966V2.668H104.99V5.868H107.87ZM109.886 24.652V15.244H112.126V24.652H109.886ZM160.318 30.06C162.174 30.06 163.454 29.708 164.158 29.036C164.862 28.3 165.31 26.252 165.566 22.892L162.43 21.836C162.302 24.364 162.046 25.836 161.694 26.284C161.278 26.668 160.606 26.892 159.71 26.892H151.486C150.462 26.892 149.95 26.38 149.95 25.388V13.58L153.47 12.428V23.788H156.766V11.34L160.542 10.092C160.542 13.868 160.478 16.076 160.414 16.684C160.35 17.388 160.126 17.772 159.742 17.772C159.166 17.772 158.462 17.74 157.662 17.74L158.59 20.844H159.102C161.534 20.844 162.942 20.076 163.294 18.572C163.614 17.036 163.774 12.684 163.774 5.516L156.766 7.852V1.164H153.47V8.972L149.95 10.156V4.012H146.622V11.276L144.35 12.044V15.404L146.622 14.668V25.9C146.622 28.652 147.966 30.06 150.718 30.06H160.318ZM138.942 1.644L136.574 3.948C139.006 5.676 140.862 7.308 142.174 8.78L144.574 6.412C143.038 4.812 141.15 3.244 138.942 1.644ZM138.366 9.484L135.998 11.788C138.27 13.452 139.998 14.988 141.214 16.46L143.582 14.06C142.174 12.524 140.414 11.02 138.366 9.484ZM140.958 18.252C139.646 22.028 138.078 25.708 136.286 29.324L139.646 30.796C141.246 27.276 142.718 23.5 143.998 19.468L140.958 18.252Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0026 32C9.92375 32 4.63539 28.6086 1.92666 23.6154C1.81969 23.4008 1.75952 23.1588 1.75952 22.9027C1.75952 22.4726 1.92917 22.0822 2.2052 21.7947L6.87513 17.1248C7.16413 16.8391 7.56143 16.6627 7.99991 16.6627C8.4384 16.6627 8.83569 16.8391 9.1247 17.1248L13.7371 21.7373C14.9868 22.9869 17.0129 22.9869 18.2626 21.7373L22.8786 17.1213C23.1673 16.8377 23.5631 16.6627 23.9998 16.6627C24.4449 16.6627 24.8475 16.8444 25.1375 17.1377L29.8269 21.827C30.0851 22.1112 30.2424 22.4885 30.2424 22.9027C30.2424 23.1519 30.1854 23.3878 30.0838 23.598C27.3795 28.6007 22.0885 32 16.0026 32Z"
      fill="#6E67F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.2424 9.09568C30.2424 9.5208 30.0766 9.90719 29.8062 10.1937L25.1373 14.8626C24.8475 15.1555 24.4449 15.3372 23.9998 15.3372C23.5577 15.3372 23.1575 15.1578 22.8679 14.868L18.2626 10.2627C17.0129 9.01306 14.9868 9.01306 13.7371 10.2627L9.13745 14.8625C8.84759 15.1555 8.44497 15.3372 7.99991 15.3372C7.55779 15.3372 7.15755 15.1578 6.86796 14.868L2.24569 10.2458C1.94631 9.9545 1.75952 9.54691 1.75952 9.09568C1.75952 8.81844 1.83004 8.55766 1.95411 8.33031C4.67037 3.36631 9.94197 0 15.9999 0C22.0859 0 27.3782 3.39757 30.0833 8.39923C30.1852 8.60978 30.2424 8.84605 30.2424 9.09568Z"
      fill="#6E67F4"
    />
  </svg>
);

const poolLogoEN = () => (
  <svg
    width="174"
    height="32"
    viewBox="0 0 174 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M55.032 23.0938H44.7976V3.95312H40.7664V26.5H55.032V23.0938ZM59.5632 7.4375C60.7507 7.4375 61.6882 6.48438 61.6882 5.32812C61.6882 4.15625 60.7507 3.21875 59.5632 3.21875C58.3757 3.21875 57.4226 4.15625 57.4226 5.32812C57.4226 6.48438 58.3757 7.4375 59.5632 7.4375ZM57.6257 26.5H61.5164V9.9375H57.6257V26.5ZM75.7507 21.5469C75.3289 22.9219 73.9539 23.8281 72.1414 23.8281C69.5945 23.8281 67.9695 22.0469 67.9695 19.3906V19.1562H79.5476V17.8906C79.5476 12.8594 76.6101 9.59375 71.907 9.59375C67.1257 9.59375 64.0945 13.0469 64.0945 18.2812C64.0945 23.5625 67.0945 26.8281 72.0632 26.8281C75.9851 26.8281 78.8914 24.6719 79.3914 21.5469H75.7507ZM71.9226 12.6094C74.157 12.6094 75.657 14.25 75.7351 16.5938H68.0007C68.157 14.2812 69.7351 12.6094 71.9226 12.6094ZM91.3289 26.7656C95.5164 26.7656 98.157 23.5156 98.157 18.2188C98.157 12.9219 95.5007 9.65625 91.3289 9.65625C88.9851 9.65625 87.0945 10.8438 86.157 12.7812H86.0632V3.95312H82.1726V26.5H85.9851V23.6719H86.0632C87.032 25.5938 88.8914 26.7656 91.3289 26.7656ZM90.1257 12.8594C92.6101 12.8594 94.1726 14.9375 94.1726 18.2188C94.1726 21.5156 92.6257 23.5781 90.1257 23.5781C87.7195 23.5781 86.0476 21.4688 86.0476 18.2188C86.0476 15 87.7195 12.8594 90.1257 12.8594ZM102.719 7.4375C103.907 7.4375 104.844 6.48438 104.844 5.32812C104.844 4.15625 103.907 3.21875 102.719 3.21875C101.532 3.21875 100.579 4.15625 100.579 5.32812C100.579 6.48438 101.532 7.4375 102.719 7.4375ZM100.782 26.5H104.673V9.9375H100.782V26.5ZM113.129 3.95312V26.5H117.16V19.0469H121.723C126.285 19.0469 129.488 16 129.488 11.5C129.488 7 126.379 3.95312 121.894 3.95312H113.129ZM117.16 7.25H120.832C123.723 7.25 125.394 8.79688 125.394 11.5C125.394 14.2344 123.707 15.7969 120.816 15.7969H117.16V7.25ZM138.754 26.8281C143.613 26.8281 146.769 23.5938 146.769 18.2188C146.769 12.8594 143.582 9.59375 138.754 9.59375C133.926 9.59375 130.738 12.875 130.738 18.2188C130.738 23.5938 133.894 26.8281 138.754 26.8281ZM138.754 23.75C136.285 23.75 134.691 21.75 134.691 18.2188C134.691 14.7031 136.301 12.6875 138.754 12.6875C141.223 12.6875 142.816 14.7031 142.816 18.2188C142.816 21.75 141.223 23.75 138.754 23.75ZM156.598 26.8281C161.457 26.8281 164.613 23.5938 164.613 18.2188C164.613 12.8594 161.426 9.59375 156.598 9.59375C151.769 9.59375 148.582 12.875 148.582 18.2188C148.582 23.5938 151.738 26.8281 156.598 26.8281ZM156.598 23.75C154.129 23.75 152.535 21.75 152.535 18.2188C152.535 14.7031 154.144 12.6875 156.598 12.6875C159.066 12.6875 160.66 14.7031 160.66 18.2188C160.66 21.75 159.066 23.75 156.598 23.75ZM167.223 26.5H171.113V3.95312H167.223V26.5Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0027 32C9.92387 32 4.63551 28.6086 1.92678 23.6154C1.81981 23.4008 1.75964 23.1588 1.75964 22.9027C1.75964 22.4726 1.92929 22.0822 2.20532 21.7947L6.87525 17.1248C7.16426 16.8391 7.56155 16.6627 8.00004 16.6627C8.43852 16.6627 8.83582 16.8391 9.12482 17.1248L13.7373 21.7373C14.987 22.9869 17.0131 22.9869 18.2628 21.7373L22.8787 17.1213C23.1674 16.8377 23.5633 16.6627 24 16.6627C24.445 16.6627 24.8477 16.8444 25.1377 17.1377L29.8271 21.827C30.0852 22.1112 30.2426 22.4885 30.2426 22.9027C30.2426 23.1519 30.1856 23.3878 30.084 23.598C27.3797 28.6007 22.0887 32 16.0027 32Z"
      fill="#6E67F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.2426 9.09568C30.2426 9.5208 30.0768 9.90719 29.8063 10.1937L25.1374 14.8626C24.8477 15.1555 24.445 15.3372 24 15.3372C23.5579 15.3372 23.1576 15.1578 22.868 14.868L18.2628 10.2627C17.0131 9.01306 14.987 9.01306 13.7373 10.2627L9.13757 14.8625C8.84771 15.1555 8.4451 15.3372 8.00004 15.3372C7.55791 15.3372 7.15767 15.1578 6.86808 14.868L2.24581 10.2458C1.94643 9.9545 1.75964 9.54691 1.75964 9.09568C1.75964 8.81844 1.83016 8.55766 1.95424 8.33031C4.67049 3.36631 9.94209 0 16 0C22.086 0 27.3784 3.39757 30.0834 8.39923C30.1854 8.60978 30.2426 8.84605 30.2426 9.09568Z"
      fill="#6E67F4"
    />
  </svg>
);

const rentLogo = () => (
  <svg
    width="167"
    height="32"
    viewBox="0 0 167 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M51.518 4.52401V7.50001H54.942V10.508H50.878V13.644H69.694V10.508H65.566V7.50001H69.15V4.52401H65.566V1.45201H62.302V4.52401H58.174V1.45201H54.942V4.52401H51.518ZM58.174 10.508V7.50001H62.302V10.508H58.174ZM67.838 15.34H52.926V30.604H56.158V29.42H64.606V30.636H67.838V15.34ZM56.158 26.412V23.82H64.606V26.412H56.158ZM56.158 20.94V18.316H64.606V20.94H56.158ZM49.022 1.51601C48.19 2.86001 47.294 4.10801 46.366 5.19601C45.534 4.01201 44.574 2.86001 43.454 1.74001L40.83 3.75601C42.078 4.87601 43.134 6.12401 44.03 7.46801C42.75 8.55601 41.438 9.42001 40.03 10.092L41.822 13.004C43.23 12.108 44.446 11.212 45.534 10.38C45.534 10.38 45.534 10.412 45.566 10.476C45.886 11.34 46.142 12.364 46.334 13.548C44.83 16.012 42.718 18.156 39.998 19.98L41.886 22.796C43.71 21.42 45.342 19.788 46.782 17.868C46.814 18.508 46.846 19.244 46.846 20.012C46.846 23.916 46.526 26.252 45.95 27.02C45.694 27.34 45.182 27.532 44.35 27.532C43.422 27.532 42.43 27.468 41.406 27.34L42.398 30.444C43.07 30.476 43.966 30.508 45.086 30.508C46.334 30.508 47.326 30.22 48.094 29.644C49.374 28.556 50.046 25.42 50.046 20.172C49.95 15.404 49.438 11.724 48.51 9.13201C48.382 8.81201 48.222 8.46001 48.062 8.10801C49.278 6.82801 50.526 5.19601 51.774 3.21201L49.022 1.51601ZM95.838 26.988C97.918 26.988 98.974 25.836 98.974 23.532V10.476H88.542V6.15601C93.022 5.70801 96.958 5.06801 100.35 4.23601L98.654 1.32401C91.55 2.86001 82.91 3.66001 72.702 3.66001L73.758 6.79601C77.854 6.79601 81.63 6.66801 85.15 6.44401V10.476H74.686V27.052H78.014V13.676H85.15V30.892H88.542V13.676H95.646V22.796C95.646 23.436 95.326 23.788 94.718 23.788L91.934 23.628L92.798 26.988H95.838ZM105.438 6.54001V30.86H108.702V6.54001H105.438ZM128.382 30.572C130.814 30.572 132.062 29.292 132.062 26.764V2.54001H116.894V5.61201H128.798V25.836C128.798 26.956 128.414 27.532 127.678 27.532L124.798 27.436L125.694 30.572H128.382ZM118.238 17.868C120.894 20.492 123.038 23.02 124.638 25.452L127.23 22.828C125.054 20.14 122.43 17.42 119.294 14.668C119.774 12.844 120.19 10.732 120.542 8.33201H117.022C116.51 12.172 115.71 15.244 114.622 17.484C113.47 19.596 111.806 21.484 109.598 23.18L111.71 25.868C114.366 23.82 116.382 21.548 117.726 19.02C117.886 18.636 118.046 18.252 118.238 17.868ZM111.102 0.876007L108.062 2.25201C109.47 3.94801 110.782 5.90001 111.966 8.14001L114.974 6.57201C113.854 4.52401 112.574 2.60401 111.102 0.876007ZM163.166 2.22001H150.014V26.572H147.326V29.772H165.566V26.572H163.166V2.22001ZM153.246 26.572V21.484H159.838V26.572H153.246ZM153.246 18.348V13.292H159.838V18.348H153.246ZM153.246 10.156V5.35601H159.838V10.156H153.246ZM136.606 9.51601V12.684H140.926C139.806 15.884 138.046 18.732 135.678 21.26L137.086 24.748C138.75 22.572 140.158 20.204 141.278 17.58V30.732H144.606V17.324C145.31 18.284 146.174 19.468 147.198 20.94L149.054 18.124C147.55 16.588 146.078 15.212 144.606 13.964V12.684H148.67V9.51601H144.606V5.29201C146.014 5.00401 147.326 4.68401 148.606 4.36401L147.454 1.29201C144.318 2.25201 140.734 2.92401 136.734 3.24401L137.406 6.25201C138.718 6.12401 139.998 5.96401 141.278 5.80401V9.51601H136.606Z"
        fill="black"
      />
      <path
        opacity="0.35"
        d="M-0.134888 10.6667C-0.134888 4.77563 4.64074 0 10.5318 0C16.4228 0 21.1984 4.77563 21.1984 10.6667V32H10.5318C4.64075 32 -0.134888 27.2244 -0.134888 21.3333V10.6667Z"
        fill="#27BEAA"
      />
      <path
        d="M10.5318 21.3333C10.5318 15.4423 15.3074 10.6667 21.1985 10.6667C27.0895 10.6667 31.8651 15.4423 31.8651 21.3333C31.8651 27.2244 27.0895 32 21.1985 32H10.5318V21.3333Z"
        fill="#27BEAA"
      />
    </g>
  </svg>
);

const rentLogoEN = () => (
  <svg
    width="178"
    height="32"
    viewBox="0 0 178 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M55.032 23.0938H44.7976V3.95312H40.7664V26.5H55.032V23.0938ZM59.5632 7.4375C60.7507 7.4375 61.6882 6.48438 61.6882 5.32812C61.6882 4.15625 60.7507 3.21875 59.5632 3.21875C58.3757 3.21875 57.4226 4.15625 57.4226 5.32812C57.4226 6.48438 58.3757 7.4375 59.5632 7.4375ZM57.6257 26.5H61.5164V9.9375H57.6257V26.5ZM75.7507 21.5469C75.3289 22.9219 73.9539 23.8281 72.1414 23.8281C69.5945 23.8281 67.9695 22.0469 67.9695 19.3906V19.1562H79.5476V17.8906C79.5476 12.8594 76.6101 9.59375 71.907 9.59375C67.1257 9.59375 64.0945 13.0469 64.0945 18.2812C64.0945 23.5625 67.0945 26.8281 72.0632 26.8281C75.9851 26.8281 78.8914 24.6719 79.3914 21.5469H75.7507ZM71.9226 12.6094C74.157 12.6094 75.657 14.25 75.7351 16.5938H68.0007C68.157 14.2812 69.7351 12.6094 71.9226 12.6094ZM91.3289 26.7656C95.5164 26.7656 98.157 23.5156 98.157 18.2188C98.157 12.9219 95.5007 9.65625 91.3289 9.65625C88.9851 9.65625 87.0945 10.8438 86.157 12.7812H86.0632V3.95312H82.1726V26.5H85.9851V23.6719H86.0632C87.032 25.5938 88.8914 26.7656 91.3289 26.7656ZM90.1257 12.8594C92.6101 12.8594 94.1726 14.9375 94.1726 18.2188C94.1726 21.5156 92.6257 23.5781 90.1257 23.5781C87.7195 23.5781 86.0476 21.4688 86.0476 18.2188C86.0476 15 87.7195 12.8594 90.1257 12.8594ZM102.719 7.4375C103.907 7.4375 104.844 6.48438 104.844 5.32812C104.844 4.15625 103.907 3.21875 102.719 3.21875C101.532 3.21875 100.579 4.15625 100.579 5.32812C100.579 6.48438 101.532 7.4375 102.719 7.4375ZM100.782 26.5H104.673V9.9375H100.782V26.5ZM117.16 18.0156H121.519L125.957 26.5H130.551L125.629 17.4062C128.316 16.4375 129.879 13.9531 129.879 10.9688C129.879 6.65625 126.957 3.95312 122.082 3.95312H113.129V26.5H117.16V18.0156ZM117.16 7.21875H121.629C124.176 7.21875 125.754 8.6875 125.754 11.0625C125.754 13.5 124.269 14.9219 121.707 14.9219H117.16V7.21875ZM143.613 21.5469C143.191 22.9219 141.816 23.8281 140.004 23.8281C137.457 23.8281 135.832 22.0469 135.832 19.3906V19.1562H147.41V17.8906C147.41 12.8594 144.473 9.59375 139.769 9.59375C134.988 9.59375 131.957 13.0469 131.957 18.2812C131.957 23.5625 134.957 26.8281 139.926 26.8281C143.848 26.8281 146.754 24.6719 147.254 21.5469H143.613ZM139.785 12.6094C142.019 12.6094 143.519 14.25 143.598 16.5938H135.863C136.019 14.2812 137.598 12.6094 139.785 12.6094ZM149.926 26.5H153.816V16.9062C153.816 14.5312 155.238 12.9219 157.473 12.9219C159.691 12.9219 160.785 14.2344 160.785 16.5781V26.5H164.676V15.7969C164.676 11.9688 162.598 9.625 158.941 9.625C156.394 9.625 154.629 10.8125 153.738 12.7812H153.66V9.9375H149.926V26.5ZM168.879 6.0625V9.9375H166.504V12.9375H168.879V22.0938C168.879 25.3125 170.285 26.5781 173.863 26.5781C174.691 26.5781 175.457 26.5156 175.879 26.4219V23.4531C175.629 23.5 175.129 23.5312 174.769 23.5312C173.394 23.5312 172.769 22.9062 172.769 21.5469V12.9375H175.894V9.9375H172.769V6.0625H168.879Z"
        fill="black"
      />
      <path
        opacity="0.35"
        d="M-0.134888 10.6667C-0.134888 4.77563 4.64074 0 10.5318 0C16.4228 0 21.1984 4.77563 21.1984 10.6667V32H10.5318C4.64075 32 -0.134888 27.2244 -0.134888 21.3333V10.6667Z"
        fill="#27BEAA"
      />
      <path
        d="M10.5317 21.3333C10.5317 15.4423 15.3074 10.6667 21.1984 10.6667C27.0894 10.6667 31.8651 15.4423 31.8651 21.3333C31.8651 27.2244 27.0894 32 21.1984 32H10.5317V21.3333Z"
        fill="#27BEAA"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="178" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const IconDropdown = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.6036 18.172C13.7874 18.4637 14.2128 18.4637 14.3966 18.172L18.0854 12.3176C18.282 12.0055 18.0577 11.5991 17.6889 11.5991H10.3113C9.94241 11.5991 9.71813 12.0055 9.91477 12.3176L13.6036 18.172Z" />
  </svg>
);

const LogoVoter = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C11.5817 8 8 11.5817 8 16V21C8 22.6569 9.34315 24 11 24H16C20.4183 24 24 20.4183 24 16C24 11.5817 20.4183 8 16 8ZM10.6753 16.4759C10.5067 16.2997 10.5441 16.1536 10.5891 16.0824C10.6341 16.0112 11.0621 15.5743 11.1445 15.5106C11.2217 15.451 11.4296 15.3604 11.6432 15.4953C11.8568 15.6302 14.4041 17.6278 14.4041 17.6278C16.1679 15.4755 18.1903 13.4748 20.3662 11.8668C20.4953 11.7714 20.6893 11.7231 20.8384 11.8171C20.9874 11.911 21.3147 12.2059 21.3925 12.2967C21.4703 12.3874 21.4994 12.5196 21.2671 12.7359C18.8106 15.0237 16.909 17.6278 15.0022 20.6129C14.8422 20.8635 14.5601 20.6881 14.2528 20.4136C13.9677 20.159 11.6938 17.6615 10.6753 16.4759Z"
    />
  </svg>
);

const LogoMonitor = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 24.0002C20.4183 24.0002 24 20.4185 24 16.0002C24 11.582 20.4183 8.00024 16 8.00024C11.5817 8.00024 8 11.582 8 16.0002C8 20.4185 11.5817 24.0002 16 24.0002ZM19.3141 11.5813L14.8952 11.5814V13.7909L12.6855 13.7908V20.4194H19.3141V18.2099H14.8951L14.8952 13.7909L19.3141 13.7908V11.5813Z"
    />
  </svg>
);
